import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ApiKeyService } from './services';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [ApiKeyService],
})
export class ApiKeyWebModule {}
